<template>
  <div class="setup-container">
    <div class="navigation">
      <button class="button" v-on:click="setup" tabindex="1" ref="n1">
        SLIDESHOWS
      </button>
      <button class="button" v-on:click="appInfo" tabindex="2">
        APP INFO
      </button>
    </div>

    <div class="collection-list">
      <div
        class="collection"
        tabindex="0"
        v-for="slideshow in slideshows"
        v-bind:style="{ 'background-image': 'url(' + slideshow.slides[0].preview_image + '?t=' + timestamp + '), url(' + slideshow.slides[0].image + '?t=' + timestamp + '), url(https://powerslide-images.s3.amazonaws.com/placeholder.svg)' }"
        v-bind:key="slideshow._id"
        v-on:click="viewSelection(slideshow)">
          <div class="collection-title">
            {{slideshow.name}}
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/base.css'
import Helpers from '../mixins/helpers.js'

export default {
  name: 'Setup',
  data () {
    return {
      slideshows: [],
      timestamp: new Date().getTime(),
      user: {}
    }
  },

  methods: {
    appInfo: function () {
      if (this.$route.path !== '/app-info') {
        this.$router.push('/app-info')
      }
    },

    getUserSlideshows: function () {
      this.axios.get('/api/slideshow/' + PS.user.organization_id).then((response) => {
        this.timestamp = new Date().getTime()

        if (response.data !== undefined) {
          this.slideshows = response.data
        } else {
          this.slideshows = []
        }

        localStorage.setItem('slideshows', JSON.stringify(this.slideshows))
      }).catch((errors) => {
        localStorage.clear()
        this.$router.push('/login')
      })
    },

    getUserData: function () {
      this.axios.get('api/user')
        .then((response) => {
          PS.user = response.data.user
          localStorage.setItem('user', JSON.stringify(response.data.user))
          this.getUserSlideshows()
        }).catch((errors) => {
          localStorage.clear()
          this.$router.push('/login')
        })
    },

    setup: function () {
      if (this.$route.path !== '/setup') {
        this.$router.push('/setup')
      }
    },

    viewSelection: function (slideshow) {
      if (this.isFireTV(PS.platform) || this.isAndroid(PS.platform)) {
        window.plugins.insomnia.keepAwake()
      }

      this.$router.push({name: 'slider2', params: { slideshow: slideshow }})
    }
  },

  mixins: [Helpers],

  mounted () {
    const n1 = this.$refs.n1
    n1.focus()
    this.getUserData()
  }
}
</script>

<style scoped>
  .button {
    font-size: 1em;
    outline: none;
    padding: .75em;
    width: 150px;
  }

  .collection:focus {
    border: 5px solid var(--secondary);
    border-radius: 8px;
    outline: none;
    transform: scale(1.1);
    transition: all 0.25s ease-in;
  }

  .collection {
    background: rgb(48, 48, 48);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border: none;
    border-radius: 8px;
    display: inline-block;
    height: 216px;
    margin: 2em;
    padding: 0;
    width: 348px;
    transition: all 0.25s ease-out;
  }

  .collection-list {
    text-align: center;
  }

  .collection-title {
    background: rgba(000,000,000,.8);
    bottom: 0;
    color: white;
    font-size: 1.5em;
    position: absolute;
    width: 100%;
  }

  img {
    height: 100%;
    width: 100%;
  }

  .navigation {
    background: var(--secondary);
    text-align: center;
    width: 100vw;
  }

  .nav-item {
    display: inline-block;
    padding: 1em;
  }

  .setup-container {
    background: black;
    min-height: 100vh;
  }

  .title {
    color: white;
    font-size: 2.5em;
  }
</style>
